<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>
    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-col cols="12" md="3">
                    <v-alert class='text-caption' dense shaped text type="info">
                        Selecciona Periodo a Consultar !!!
                    </v-alert>
                </v-col>
                <v-col cols="6" md="3">
                    <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field rounded v-model="date1" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="6" md="3">
                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field rounded v-model="date2" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="6" md="3">
                    <v-btn class="mt-1 ml-2" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="mt-2">
                <v-col cols="6">
                    <h5>Ventas del Periodo</h5>
                    <v-container>
                        <v-data-table height="200px" dense :headers="headers" :items="items" 
                            :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event"
                            hide-default-footer class="elevation-1 text-size" dark>
                        </v-data-table>
                        <h5 class="mt-3">Metrica del Negocio</h5>
                        <v-row class="mt-0">
                            <v-col cols="12" md="1"></v-col>
                            <v-col class="text-center" cols="12" md="3">
                                <v-progress-circular :rotate="360" :size="80" :width="15" :value="20" color="warning">20%</v-progress-circular>
                                <h6>Costo</h6>
                            </v-col>
                            <v-col class="text-center" cols="12" md="3">
                                <v-progress-circular :rotate="360" :size="80" :width="15" :value="20" color="indigo">20%</v-progress-circular>
                                <h6>Venta</h6>
                            </v-col>
                            <v-col class="text-center" cols="12" md="3">
                                <v-progress-circular :rotate="360" :size="80" :width="15" :value="20" color="success">20%</v-progress-circular>
                                <h6>Utilidad</h6>
                            </v-col>
                            <v-col cols="12" md="1"></v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-col cols="6">
                    <h5>Ordenes del Periodo</h5>
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-card color="indigo" dark max-height="100">
                                    <v-card-title>
                                        <v-icon large>store</v-icon>
                                        <v-spacer></v-spacer>
                                        <h3>10</h3>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <strong style="font-family:calibri;font-size:9pt">PENDIENTES</strong>
                                        <v-spacer></v-spacer>
                                        <v-icon class="ml-2" color="white" small>refresh</v-icon>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-card color="success" dark max-height="100">
                                    <v-card-title>
                                        <v-icon large>store</v-icon>
                                        <v-spacer></v-spacer>
                                        <h3>10</h3>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <strong style="font-family:calibri;font-size:9pt">ENTREGADOS</strong>
                                        <v-spacer></v-spacer>
                                        <v-icon class="ml-2" color="white" small>refresh</v-icon>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-card color="red" dark max-height="100">
                                    <v-card-title>
                                        <v-icon large>store</v-icon>
                                        <v-spacer></v-spacer>
                                        <h3>10</h3>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <strong style="font-family:calibri;font-size:9pt">DEVOLUCIONES</strong>
                                        <v-spacer></v-spacer>
                                        <v-icon class="ml-2" color="white" small>refresh</v-icon>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                        <div class="mt-7">
                            <GChart type="ColumnChart" :data="chartData" :options="chartOptions"/>
                        </div>
                    </v-container>
                </v-col>
            </v-row>
            <v-divider></v-divider>
        </v-container>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 10pt !important;
    height: 26px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
.col-color-blue-grey >>> th {
    background-color: #c5e3e7;
}
</style>
<script>
import axios from 'axios';
import { GChart } from 'vue-google-charts/legacy'
export default {
    name: 'Dashboard',
    components: { GChart },
    data(){
        return {
            contrato:null,
            user:null,
            apikey:null,

            menor1:7,
            menor2:3,
            menor3:2,
            mayor1:10,
            mayor2:5,
            mayor3:2,
            chartData: [],
            chartOptions: {
                title: 'Calidad  :: Tiempos de Respuestas',
                legend: { position: 'bottom' },
                colors: ['blue', 'green', 'red']
            },
            headers: [
                { text: 'Canal', align: 'start', sortable: true, value: 'canal' },
                { text: 'Costo', align: 'start', sortable: true, value: 'costo' },
                { text: 'Venta', align: 'start', sortable: true, value: 'venta' },
                { text: 'Utilidad', align: 'center', sortable: true, value: 'utilidad' },
            ],
            items: [],
            page: 1,
            pageCount: 0,
            itemsPerPage: 1000000,
            menu1:false,
            date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu2:false,
            date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            bloqueo:null,
            loading:false,
        }
    },
    async mounted(){
        this.user=localStorage.getItem('user');
        this.apikey=localStorage.getItem('apiKey');
        this.contrato=localStorage.getItem('contrato');
        //this.grafico()
        const estadistica=[
            ['Respuestas','Pendientes', 'Entregados','Devoluciones'],
            ['< 5 Dias', parseFloat(this.menor1),parseFloat(this.menor2),parseFloat(this.menor3)],
            ['> 5 Dias', parseFloat(this.mayor1),parseFloat(this.mayor2),parseFloat(this.mayor3)],
        ];
        this.chartData=estadistica;
        this.bloqueo = await this.myPermiso(1);
    },
    methods:{
        async myPermiso(id){
            let result = 0;
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user : this.user,
                    id : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = parseInt(datos[0].acceso);
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async grafico(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/dash/grafico/punto/venta/'+this.contrato);
            const datos=response.data;
            if (datos[0].existe=='si'){ 
                datos.forEach(element => {
                    if (element.punto=='Local'){ 
                        this.menor1=element.Menor;
                        this.mayor1=element.Mayor
                    }
                    if (element.punto=='Web'){ 
                        this.menor2=element.Menor;
                        this.mayor2=element.Mayor
                    }
                    if (element.punto=='Comercio'){ 
                        this.menor3=element.Menor;
                        this.mayor3=element.Mayor
                    }
                });
                const estadistica=[
                    ['Respuestas','Local', 'web','Comercio'],
                    ['< 5 Dias', parseFloat(this.menor1),parseFloat(this.menor2),parseFloat(this.menor3)],
                    ['> 5 Dias', parseFloat(this.mayor1),parseFloat(this.mayor2),parseFloat(this.mayor3)],
                ];
                this.chartData=estadistica;
            }
        },
        

    }
}
</script>